import React from 'react';
import { Grid, Box } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { TransformationHeading } from './common/fields/Heading';
import { COMMON_STYLES, COMMON_VALIDATION, COMMON_VALIDATION_PARAM } from './common/Constants';
import { SourceColumnField } from './common/fields/SourceColumnField';
import { OutputColumnField } from './common/fields/OutputColumnField';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'split',
  alias: '',
  df: '',
  transformations: [
    {
      sourceColumns: [''],
      outputColumn: '',
      param: '',
    },
  ],
};

const validationSchema = {
  ...COMMON_VALIDATION,
  ...COMMON_VALIDATION_PARAM('Enter character to split on'),
};

const renderTransformationFields = ({ formField, errors, setFieldValue, disableForm, headers }) => {
  const renderField = ({ transform, index, headers, disableForm, errors }) => {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} mb={2} />
          <Grid item xs={12} sm={6}>
            <SourceColumnField
              value={transform.sourceColumns[0] || ''}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].sourceColumns = [e.target.value];
                setFieldValue('transformations', newTransforms);
              }}
              headers={headers}
              disabled={disableForm}
              error={!!errors?.sourceColumns}
              helperText="Select text column to split"
            />
          </Grid>
          <Grid item {...COMMON_STYLES.gridItem}>
            <OutputColumnField
              value={transform.param}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].param = e.target.value;
                setFieldValue('transformations', newTransforms);
              }}
              disabled={disableForm}
              label="Delimiter *"
              helperText={errors?.param || 'Character to split on'}
              error={!!errors.param}
            />
          </Grid>
          <Grid item {...COMMON_STYLES.gridItem}>
            <OutputColumnField
              value={transform.outputColumn}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].outputColumn = e.target.value;
                setFieldValue('transformations', newTransforms);
              }}
              disabled={disableForm}
              error={!!errors.outputColumn}
              helperText={errors?.outputColumn}
            />
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading
        title='Split - Divide text into parts ( "a,b,c" → ["a","b","c"] ) (delimiter: ",")'
        disabled={disableForm}
      />
      <TransformationArrayField
        transformations={formField.transformations}
        setTransformations={(newTransforms) => setFieldValue('transformations', newTransforms)}
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
      />
    </Box>
  );
};

const NodeModal_Split = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    validationSchema={validationSchema}
    renderTransformationFields={renderTransformationFields}
    transformationType={INITIALSTATE.type}
    tranformationName="Split"
  />
);

export default NodeModal_Split;
